// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import List from '@mui/material/List';

// project import
import NavGroup from './NavGroup';
import NavItem from './NavItem';
import NavCollapse from './NavCollapse';
import menuItem from 'menu-items';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const navGroups = menuItem.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      case 'collapse':
        return (
          <List key={item.id} sx={{ mb: 1.5, py: 0, zIndex: 0 }}>
            <NavCollapse item={item} level={1} />
          </List>
        );
      case 'item':
        return (
          <List key={item.id} sx={{ mb: 1.5, py: 0, zIndex: 0 }}>
            <NavItem item={item} level={1} />
          </List>
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
